<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import UiButton from '../components/Ui/Button.vue';

import i18n from '../i18n';
import store from '../store';
import { CAN_POST_MESSAGE } from '../consts';
import { log } from '../log';

export default {
  i18n,
  store,
  name: 'UpcTrigger',
  components: {
    UiButton,
  },
  props: [],
  data: () => ({
    CAN_POST_MESSAGE,
  }),
  computed: {
    ...mapGetters([
      'stateData',
      'stateDataKeyActions',
    ]),
    ...mapState([
      'isPopUpOpen',
      'state',
      'purchaseWindow',
      'redeemWindow',
      'purchaseWindow',
      'accountKeyReplacePayload',
      'accountKeyRecoverPayload',
      'accountTrialExtendPayload',
      'iframeUrl',
    ]),
    copy() {
      // if (this.state === 'BASIC' || this.state === 'PLUS') return this.$t('upcTrigger.upgrade');
      return '';
    },
  },
  methods: {
    ...mapActions([
      'jumpToUpc',
      'openPopUp',
      'closePopUp',
      'startTrial',
    ]),
    niceTry() {
      log.log('❌ Nice try you little sneak ❌');
    },
  },
};
</script>

<template>
  <transition appear name="fade" mode="out-in">
    <div v-if="stateData && stateData.actions" class="flex flex-wrap pl-12px">
      <p class="w-7/20 pr-12px" v-html="copy"></p>
      <div class="w-13/20">
        <div class="flex flex-col max-w-300px gap-y-4">
          <template v-if="!isPopUpOpen">
            <UiButton
              v-if="stateData.actions.includes('startTrial')"
              @btn-click="startTrial()"
              :text="iframeUrl ? `${$t('actions.startTrial')} (new tab)` : $t('actions.startTrial')"
              class="button button-alt" />
            <!-- purchase / redeem / upgrade subset of buttons -->
            <UiButton
              v-if="stateData.actions.includes('purchase')"
              @btn-click="openPopUp(purchaseWindow)"
              :hrefUrl="CAN_POST_MESSAGE ? purchaseWindow.url : iframeUrl"
              :href-external="!!iframeUrl"
              :text="iframeUrl ? `${$t('actions.purchase')} (new tab)` : $t('actions.purchase')"
              class="button button-alt" />
            <UiButton
              v-if="stateData.actions.includes('purchase')"
              @btn-click="openPopUp(redeemWindow)"
              :hrefUrl="CAN_POST_MESSAGE ? redeemWindow.url : iframeUrl"
              :href-external="!!iframeUrl"
              :text="iframeUrl ? `Redeem Activation Code (new tab)` : 'Redeem Activation Code'"
              class="button button-alt" />
            <UiButton
              v-if="stateData.actions.includes('upgrade')"
              @btn-click="openPopUp(purchaseWindow)"
              :hrefUrl="CAN_POST_MESSAGE ? purchaseWindow.url : iframeUrl"
              :href-external="!!iframeUrl"
              :text="iframeUrl ? `${$t('actions.upgrade')} (new tab)` : $t('actions.upgrade')"
              class="button button-alt" />
            <!-- replace / recover key -->
            <UiButton
              v-if="stateData.actions.includes('replace')"
              :hrefUrl="iframeUrl"
              :href-external="!!iframeUrl"
              @btn-click="openPopUp(accountKeyReplacePayload)"
              :text="iframeUrl ? `${$t('actions.replace')} (new tab)` : $t('actions.replace')"
              class="button" />
            <UiButton
              v-if="stateData.actions.includes('recover')"
              :hrefUrl="iframeUrl"
              :href-external="!!iframeUrl"
              @btn-click="openPopUp(accountKeyRecoverPayload)"
              :text="iframeUrl ? `${$t('actions.recover')} (new tab)` : $t('actions.recover')"
              class="button" />
            <!-- trial related buttons -->
            <UiButton
              v-if="stateData.actions.includes('extend')"
              :hrefUrl="iframeUrl"
              :href-external="!!iframeUrl"
              @btn-click="openPopUp(accountTrialExtendPayload)"
              :text="iframeUrl ? `${$t('actions.extend')} (new tab)` : $t('actions.extend')"
              class="button" />
          </template>
          <template v-else>
            <button
              @click="openPopUp()"
              type="button"
              class="button button-alt"
            >{{ $t('backToPopUp') }}</button>
            <button
              @click="closePopUp()"
              type="button"
              class="hover:underline text-14px"
            >{{ $t('closePopUp') }}</button>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="postcss">
@tailwind base;
@tailwind components;
@tailwind utilities;

.button {
  @apply text-orange;
  @apply font-semibold;
  @apply leading-none;
  @apply uppercase;
  @apply tracking-wide;
  @apply text-center;
  @apply no-underline;
  @apply bg-transparent;
  @apply text-14px;
  @apply px-16px;
  @apply py-12px;

  background:
    /* top */
    linear-gradient(
      to right,
      #e03237 0%,
      #fd8c3c 100%
    )
    left
    top
    no-repeat,
    /* bottom */
    linear-gradient(
      to right,
      #e03237 0%,
      #fd8c3c 100%
    )
    left
    bottom
    no-repeat,
    /* right */
    linear-gradient(
      to top,
      #e03237 0%,
      #e03237 100%
    )
    left
    bottom
    no-repeat,
    /* right */
    linear-gradient(
      to top,
      #fd8c3c 0%,
      #fd8c3c 100%
    )
    right
    bottom
    no-repeat;
  background-size: 100% 2px, 100% 2px, 2px 100%, 2px 100%;
  border: 0;

  &:active {
    transform: scale(.975);
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &:hover,
  &:focus {
    @apply text-white;
    background: linear-gradient(to right, theme('colors.red') 0%, theme('colors.orange') 100%);
    box-shadow: 0;
  }
}

.button-alt {
  @apply text-white;
  @apply font-semibold;
  @apply leading-none;
  @apply uppercase;
  @apply tracking-wide;
  @apply text-center;
  @apply no-underline;
  @apply inline-block;
  @apply rounded-sm;

  background: linear-gradient(to right, theme('colors.red') 0%, theme('colors.orange') 100%);
  transition: none;

  &:active {
    transform: scale(.975);
  }

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  &:hover,
  &:focus {
    @apply bg-transparent;
    @apply text-orange;
    background:
      /* top */
      linear-gradient(
        to right,
        #e03237 0%,
        #fd8c3c 100%
      )
      left
      top
      no-repeat,
      /* bottom */
      linear-gradient(
        to right,
        #e03237 0%,
        #fd8c3c 100%
      )
      left
      bottom
      no-repeat,
      /* right */
      linear-gradient(
        to top,
        #e03237 0%,
        #e03237 100%
      )
      left
      bottom
      no-repeat,
      /* right */
      linear-gradient(
        to top,
        #fd8c3c 0%,
        #fd8c3c 100%
      )
      right
      bottom
      no-repeat;
    background-size: 100% 2px, 100% 2px, 2px 100%, 2px 100%;
    border: 0;
    box-shadow: 0;
  }
}

.button-fine-error {
  @apply underline bg-transparent rounded-sm;

  &:hover,
  &:focus {
    @apply text-white bg-red no-underline;
  }
}

/*! purgecss start ignore */
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion) {
  * { transition-duration: 0 !important }
}

[v-cloak] { display: none }
/*! purgecss end ignore */
</style>
